import type { ComponentType, ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { HlsConfig } from 'hls.js';

type MediaViewerConfig<TPlayer = unknown> = {
  showFullScreenButton: boolean;
  showResolutionPicker: boolean;
  showTranscripts: boolean;
  showTranscriptionPanel: boolean;
  showContentCredentials: boolean;
  defaultHlsConfig?: Partial<HlsConfig>;
  PlayheadSyncButton?: ComponentType;
  PlayheadSync?: ComponentType<{ playerInterface: TPlayer }>;
  onDownloadUrl?: (url: string) => void;
  onTimestampSelected?: (args: {
    commentId: string;
    timestampMicroseconds: number;
    assetId?: string | null;
  }) => void;
};

const defaultConfig: MediaViewerConfig = {
  showFullScreenButton: true,
  showResolutionPicker: true,
  showTranscripts: true,
  showTranscriptionPanel: true,
  showContentCredentials: false,
};

const MediaViewerConfigContext =
  createContext<MediaViewerConfig>(defaultConfig);

export const MediaViewerConfigProvider = <TPlayer,>({
  children,
  value,
}: {
  children: ReactNode;
  value: MediaViewerConfig<TPlayer>;
}) => (
  <MediaViewerConfigContext.Provider value={value as MediaViewerConfig}>
    {children}
  </MediaViewerConfigContext.Provider>
);

export const useMediaViewerConfig = () => useContext(MediaViewerConfigContext);

export type { MediaViewerConfig };
